// There are styles attached to these classes. If changed, make sure to change the styles too.
export const copyTextClass = "copy-text-field"
export const copyBtnId = "copy-text-btn";
const tooltipAttr = "data-copy-tooltip";

/**
 * Copies text from a field with class copyTextClass to clipboard when a button with
 * id copyBtnId is clicked.
 */
export const initCopyTextField = () => {
    const copyTextField = document.querySelector(`.${copyTextClass}`);
    const copyBtn = document.getElementById(copyBtnId);

    copyBtn.addEventListener("click", () => {
        navigator.clipboard.writeText(copyTextField.innerText);
    
        // Show tooltip on click
        copyBtn.setAttribute(tooltipAttr, "Copied!");
        setTimeout(() => {
            copyBtn.setAttribute(tooltipAttr, "Copy");
        }, 2000);
    });
}